var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pagination" }, [
    _c("nav", { class: _vm.props.theme.nav }, [
      _c(
        "ul",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.props.showPagination,
              expression: "props.showPagination"
            }
          ],
          class: _vm.props.theme.list
        },
        [
          _c(
            "li",
            {
              staticClass: "pagination__item",
              on: { click: _vm.props.setPrevPage }
            },
            [
              _c(
                "a",
                _vm._b(
                  {},
                  "a",
                  Object.assign({}, _vm.props.aProps, _vm.props.prevProps),
                  false
                ),
                [
                  _c("img", {
                    staticClass: "pagination__image-left",
                    attrs: { src: "/static/icons/angle-right.svg" }
                  })
                ]
              )
            ]
          ),
          _vm._l(_vm.props.pages, function(page) {
            return _c(
              "li",
              _vm._g(
                { key: page, staticClass: "pagination__item" },
                _vm.props.pageEvents(page)
              ),
              [
                _c(
                  "a",
                  _vm._b(
                    { class: _vm.props.theme.link },
                    "a",
                    _vm.props.aProps,
                    false
                  ),
                  [_vm._v("\n            " + _vm._s(page) + "\n          ")]
                )
              ]
            )
          }),
          _c(
            "li",
            {
              staticClass: "pagination__item",
              on: { click: _vm.props.setNextPage }
            },
            [
              _c(
                "a",
                _vm._b(
                  {},
                  "a",
                  Object.assign({}, _vm.props.aProps, _vm.props.nextProps),
                  false
                ),
                [_c("img", { attrs: { src: "/static/icons/angle-right.svg" } })]
              )
            ]
          )
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-665e07ad", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-665e07ad","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pagination/index.vue
// module id = 543
// module chunks = 42